import React from 'react';
import { Link } from 'react-router-dom';

const VARIANTS = {
  primary: 'bg-cream text-ink hover:bg-white',
  cobalt: 'bg-cobalt text-cream hover:bg-[#2563eb]',
  ghost: 'border border-line text-cream hover:border-cream/40 hover:bg-white/5',
  link: 'text-sky hover:text-cream px-0 py-0',
};
const SIZES = { sm: 'h-10 px-4 text-sm', md: 'h-12 px-6 text-[15px]', lg: 'h-14 px-8 text-base' };

// One button vocabulary for the whole marketing site. `to` renders a router
// Link, `href` an anchor, otherwise a <button>.
export default function Button({ variant = 'primary', size = 'md', to, href, className = '', children, ...rest }) {
  const base = 'inline-flex items-center justify-center gap-2 rounded-full font-medium tracking-tight transition-colors duration-300 ease-expo disabled:opacity-50 disabled:cursor-not-allowed select-none';
  const cls = [base, VARIANTS[variant] || VARIANTS.primary, variant === 'link' ? '' : SIZES[size], className].join(' ');
  if (to) return <Link to={to} className={cls} {...rest}>{children}</Link>;
  if (href) return <a href={href} className={cls} {...rest}>{children}</a>;
  return <button type="button" className={cls} {...rest}>{children}</button>;
}
